<template>
  <div class="bottom__container">
    <div class="intro__link">
      <div @click="$store.commit('toggleAbout')" class="intro__about"
        >ABOUT <img id="arrow" v-if="!$store.state.About" src="../assets/img/tempelli-arrow-out.svg"
      /><img v-else src="../assets/img/tempelli-close.svg"
      /></div>
      <!-- <router-link to="/"
        >ABOUT <img src="../assets/img/tempelli-arrow-out.svg"
      /></router-link> -->
      <div class="bottom__control" v-if="!$store.state.About">
        {{ prj }}/{{ totPrj + 1 }}
        <div>
          <img
            src="../assets/img/tempelli-carret-r.svg"
            alt=""
            @click="backwardNew"
          />
          <img
            id="right"
            src="../assets/img/tempelli-carret-r.svg"
            alt=""
            @click="forwardNew"
          />
          <!-- <a href="#3">
          <img
            id="right"
            src="../assets/img/tempelli-carret-r.svg"
            alt=""
          />
          </a> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    totPrj() {
      return this.$store.state.Prj.length;
    },
    prj() {
      return this.$store.state.homePrj + 1;
    },
  },
  methods: {
    forward() {
      if (this.prj >= this.totPrj + 1)
        this.$store.commit("forwardPrj", -this.totPrj);
      else this.$store.commit("forwardPrj", 1);
    },
    forwardNew() {
      // if (this.prj >= this.totPrj + 1)
      //   this.$store.commit("forwardPrj", -this.totPrj);
      // else this.$store.commit("forwardPrj", 1);
      // console.log("DIOCANE")
      var el = document.querySelector('.slider')
      var topPos = el.offsetLeft;
      console.log(topPos)
      // document.querySelector('.imga').scrollLeft = topPos;
      el.scrollLeft += 400;
      // console.log(el)
      // el.scroll(-50,220)
    },
    backwardNew() {
      // if (this.prj >= this.totPrj + 1)
      //   this.$store.commit("forwardPrj", -this.totPrj);
      // else this.$store.commit("forwardPrj", 1);
      // console.log("DIOCANE")
      var el = document.querySelector('.slider')
      var topPos = el.offsetLeft;
      console.log(topPos)
      // document.querySelector('.imga').scrollLeft = topPos;
      el.scrollLeft -= 400;
      // console.log(el)
      // el.scroll(-50,220)
    },
    backward() {
      if (this.prj <= 1) this.$store.commit("forwardPrj", this.totPrj);
      else this.$store.commit("backwardPrj", 1);
    },
  },
  mounted() {
    var el = document.querySelector('.slider');
    el.scrollLeft = 0
  },
};
</script>

<style lang="scss" scoped>
.bottom__container {
  padding: 0 55px;
  @media screen and (max-width:767px) {
    padding: 0 20px;
  }
}
.bottom__control {
  display: flex;
  align-items: center;
  div {
    width: 42px;
    justify-content: space-between;
    margin-left: 24px;
    display: flex;
    img {
      cursor: pointer;
      transition: 200ms ease-out;
      height: 90%;
      width: auto;
      &:hover {
        transform: translate(-5px, 0);
      }
    }
    #right {
      transform: rotate(180deg);
      &:hover {
        transform: translate(5px, 0) rotate(180deg);
      }
    }
  }
}
.intro__link {
  width: 100%;
  margin-top: 48px;
  font-family: Lausanne;
  font-size: 22px;
  font-weight: bold;
  a {
    color: white;
    text-decoration: none;
    margin-right: 10px;

    display: flex;
    img {
      margin-left: 12px;
    }
    &:hover {
      text-decoration: underline;
      img {
        transition: 200ms ease-out;
        transform: translate(5px, -5px);
      }
    }
  }
  .intro__about {
    cursor: pointer;
    color: white;
    text-decoration: none;
    margin-right: 10px;

    display: flex;
    img {
      margin-left: 12px;
    }
    @media screen and (min-width:767px) {
    &:hover {
      text-decoration: underline;
      #arrow {
        transition: 200ms ease-out;
        transform: translate(5px, -5px);
      }
    }
    }
  }
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media screen and (max-width:767px) {
    margin-top: 2vh;
  }
}
</style>
